var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagKids = function SvgFlagKids(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.426 5.74q.142-1.654.282-3.49c0 .034-3.393 1.294-5.913.844-3.781-.425-6.125-.682-8.159 1.07a1.27 1.27 0 0 0-1.31-.67 1.266 1.266 0 0 0-1.062 1.435l2.41 15.997a1.27 1.27 0 0 0 1.438 1.06 1.267 1.267 0 0 0 1.063-1.436l-1.106-7.334a1.025 1.025 0 0 1 .558-1.074c.82-.405 1.965-.781 3.244-.992 1.781-.325 3.822-.33 5.604-.373 4.651-.056 5.912-2.984 6.275-3.763-1.107-.171-2.216-.64-3.324-1.275"
  })));
};
export default SvgFlagKids;